import {
    FETCH_AUTO_MESSAGES_START,
    FETCH_AUTO_MESSAGES_SUCCESS,
    FETCH_AUTO_MESSAGES_ERROR,
    UPDATE_AUTO_MESSAGE_START,
    UPDATE_AUTO_MESSAGE_SUCCESS,
    UPDATE_AUTO_MESSAGE_ERROR
} from '../actions';

const initialState = {
    messages: {
        autoReplyMessage: '',
        autoConfirmMockupMessage: '',
        autoConfirmMessage: ''
    },
    loading: false,
    error: null
};

const autoMessagesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_AUTO_MESSAGES_START:
        case UPDATE_AUTO_MESSAGE_START:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_AUTO_MESSAGES_SUCCESS:
            return {
                ...state,
                messages: {
                    autoReplyMessage: action.payload.autoReplyMessage || '',
                    autoConfirmMockupMessage: action.payload.autoConfirmMockupMessage || '',
                    autoConfirmMessage: action.payload.autoConfirmMessage || ''
                },
                loading: false,
                error: null
            };

        case UPDATE_AUTO_MESSAGE_SUCCESS:
            return {
                ...state,
                messages: {
                    ...state.messages,
                    [action.payload.messageType]: action.payload.messageContent
                },
                loading: false,
                error: null
            };

        case FETCH_AUTO_MESSAGES_ERROR:
        case UPDATE_AUTO_MESSAGE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        default:
            return state;
    }
};

export default autoMessagesReducer;